import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { StandardPayment } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveTransferList = createAsyncThunk<StandardPayment[], void, { extra: Partial<Dependencies> }>(
  "transfers/retrieveTransferList",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listTransfers();
  },
);
